import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type TotalSelector = (state: ReduxState) => number

const getTotalSelector: TotalSelector = (state) => state.productSizes.pagination.total

export const totalSelector: TotalSelector = createSelector(getTotalSelector, (currentPage) => currentPage)
